import Services from './base-services'

const service = new Services('mdDiagnostico')

export default {
    findDiagnosticoPendiente(userId:any) {
        return service.get(`findDiagnosticoPendiente?userId=${userId}`)
    },
    answerDiagnostico(data: any) {
        return service.post(`answerDiagnostico`, data)
    },
}
